import {IOriginWrapper} from "~/interfaces/mappingInterfaces";
import {ModelType} from "~/enums/modelType";
import OriginWrapperFormElement from "~/models/mapping/originWrapperFormElement";

export default class OriginWrapperLookupField extends OriginWrapperFormElement implements IOriginWrapper {
  readonly type = ModelType.LookUpField
}